module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-main-wrapper"
  }, [_c('v-checkbox', {
    key: _vm.value,
    class: ("check-box check-box__" + (_vm.value ? 'activate' : 'deactivate')),
    attrs: {
      "error": _vm.error,
      "input-value": _vm.value,
      "disabled": _vm.disabled,
      "label": _vm.placeholder,
      "color": "red accent-4",
      "hide-details": _vm.details,
      "rules": _vm.rules || [],
      "false-value": _vm.falseVal,
      "true-value": _vm.trueVal
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticClass: "label"
        }, [_vm._t("default")], 2)]
      },
      proxy: true
    }], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8245180","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UiCheckbox.vue
// module id = 374
// module chunks = 2